import styled from '@emotion/styled';
import { USER_DEFAULT_AVATAR } from 'shared/constants/links';

interface ImageProps {
  src?: string;
  alt?: string;
  size?: number;
  className?: string;
  onClick?: () => void;
}

function Image(props: ImageProps) {
  const { src, alt, className, size = 60, onClick } = props;

  return (
    <Container size={size} className={className} onClick={onClick}>
      <ImageComponent src={src ?? USER_DEFAULT_AVATAR} alt={alt} />
    </Container>
  );
}

export default Image;

const Container = styled.div<{ size?: number }>`
  width: ${(props) => props.size}px;
  height: ${(props) => props.size}px;
  min-width: ${(props) => props.size}px;
  min-height: ${(props) => props.size}px;

  border-radius: 8px;
  overflow: hidden;
  border: 1px solid ${({ theme }) => theme.colors.SurfaceRomanSilver30};

  cursor: pointer;
`;

const ImageComponent = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
